import { Events } from './types';

export const EKA_EVENT = 'eka-event';

export const dispatch = (event: Events): void => {
    dispatchEvent(new CustomEvent(EKA_EVENT, { detail: event }));
};
